import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) {
    output[i] = raw.charCodeAt(i);
  }
  return output;
}

/**
 * Request notification permission and subscribe to push.
 * Returns 'granted' | 'denied' | 'unsupported' | 'error'
 */
export async function subscribeToPush() {
  if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) {
    return 'unsupported';
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return 'denied';

  try {
    /* Get VAPID public key from server */
    const { data } = await axios.get(`${API_BASE}/api/push/vapid-public-key`);
    if (!data.success) return 'error';

    const reg = window.swRegistration || await navigator.serviceWorker.ready;
    const subscription = await reg.pushManager.subscribe({
      userVisibleOnly:      true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });

    /* Send subscription to server */
    const sub = subscription.toJSON();
    await axios.post(`${API_BASE}/api/push/subscribe`, {
      endpoint: sub.endpoint,
      keys:     sub.keys,
    });

    localStorage.setItem('nel_push_subscribed', '1');
    return 'granted';
  } catch (err) {
    console.error('[Push] Subscribe error:', err);
    return 'error';
  }
}

/**
 * Unsubscribe from push notifications.
 */
export async function unsubscribeFromPush() {
  try {
    const reg = window.swRegistration || await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
      const endpoint = sub.endpoint;
      await sub.unsubscribe();
      await axios.delete(`${API_BASE}/api/push/unsubscribe`, { data: { endpoint } });
    }
    localStorage.removeItem('nel_push_subscribed');
    return true;
  } catch (err) {
    console.error('[Push] Unsubscribe error:', err);
    return false;
  }
}

/**
 * Check if user is currently subscribed.
 */
export async function isPushSubscribed() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
  try {
    const reg = window.swRegistration || await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    return !!sub;
  } catch {
    return false;
  }
}

/**
 * Get current Notification permission status.
 */
export function getNotificationPermission() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission; // 'default' | 'granted' | 'denied'
}
